import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { environment } from '../../../../environments/environment';
import { TitleService } from '../../../services/title.service';

@Component({
  selector: 'app-contact-us-page',
  imports: [MatIconModule],
  templateUrl: './contact-us-page.html',
  styleUrl: './contact-us-page.scss',
})
export class ContactUsPage {
  constructor(private titleService: TitleService) {
    this.titleService.setTitle('Contact Us');
  }

  get appname(): string {
    return environment.appname;
  }

  get email(): string {
    return environment.email;
  }

  get address1(): string {
    return environment.address1;
  }

  get address2(): string {
    return environment.address2;
  }

  get ig(): string {
    return environment.social_media.ig;
  }

  get facebook(): string {
    return environment.social_media.facebook;
  }
}
